import styled from 'styled-components';

import TextLink from '../../UI/TextLink/TextLink';
import Arrow from '../../../images/Arrow_link.svg';

export const Data = styled.div`
  width: 100%;
`;

export const StoreLogo = styled.div`
  width: 100%;
  max-width: 200px;
  padding: 2rem 0 1rem;
`;

export const StoreAddress = styled.h2`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.26;
  letter-spacing: normal;
  color: #333333;

  @media only screen and (min-width: 768px) {
    font-size: 24px;
    line-height: 1.25;
  }

  @media only screen and (min-width: 768px) {
  }
`;

export const StorePhone = styled.a`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.24;
  letter-spacing: normal;
  color: #515861;
  text-decoration: none;
  display: inline-block;

  @media only screen and (min-width: 768px) {
    font-size: 17px;
    line-height: 1.65;
  }
`;

export const Footer = styled.div`
  display: block;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;
`;

export const GoogleLink = styled(TextLink)`
  margin: 0;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:after {
    content: '';
    display: inline-block;
    width: 10px;
    height: 8px;
    margin-left: 10px;
    top: 50%;
    margin-top: -4px;
    background: url(${Arrow}) no-repeat scroll 0 0 transparent;
  }
`;

export const Times = styled.ul`
  margin: 0%;
  list-style: none;
`;

export const Time = styled.div`
  display: flex;

  p {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
  }

  span.weekday {
    display: inline-block;
    min-width: 90px;
    margin-right: 40px;
    font-weight: 600;
  }

  span.time {
    color: #515861;
  }

  .green {
    color: #276600;
  }

  .red {
    color: #eb0000;
  }

  &.not-active {
    span {
      color: #515861;
    }
  }
`;

export const SelectBtn = styled.button`
  margin-right: 23px;

  min-width: 110px;
  min-height: 30px;
  padding: 0 20px;
  border-radius: 15px;
  border: solid 1px #333333;
  background-color: #fff;
  font-size: 10px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  cursor: pointer;
  white-space: nowrap;

  &:focus,
  &:hover,
  &.active {
    box-shadow: 0 2px 3px 0 rgba(51, 51, 51, 0.2);
    background-color: #333333;
    color: #fff;
  }
`;

export const AppointmentButtonWrapper = styled.div`
  display: flex;
  margin-bottom: 29px;
`;
